<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">{{title}}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>

<div class="modal-body">
  <form autocomplete="off" [formGroup]="taskForm">

    <div class="mb-3" *ngIf="!isNote && users.length">
      <label class="form-label">User</label>
      <ng-select
        [items]="users"
        bindLabel="name"
        placeholder="Search user..."
        [(ngModel)]="selectedUser"
        [ngModelOptions]="{standalone: true}"
        (change)="checkValid()">
      </ng-select>
    </div>

    <div class="mb-3" *ngIf="!isNote">
      <label class="form-label">Due By Date</label>
      <input type="date"
             class="form-control"
             formControlName="dueByDate"
             [max]="maxDate | date:'yyyy-MM-dd'"
             [min]="minDate | date:'yyyy-MM-dd'"
             (change)="checkValid()">
    </div>

    <div class="mb-3">
      <label class="form-label">Entry</label>
      <textarea class="form-control"
                #entry
                formControlName="entry"
                placeholder="Entry"
                maxlength="300"
                rows="4"
                (keyup)="checkValid()"></textarea>
      <div class="form-text text-end">{{entry.value?.length || 0}}/300</div>
    </div>

  </form>
</div>

<div class="modal-footer">
  <button type="button"
          class="btn btn-success"
          (click)="save()"
          [disabled]="invalidSelection">
    Save
  </button>
</div>